<template>
  <v-layout wrap>
    <v-radio-group
      v-model="selected"
      hide-details
      row
      class="mt-0 pt-0"
      @change="change"
    >
      <v-radio
        label="Все поставки"
        :value="0"
      />
      <v-radio
        label="Не в машине"
        :value="1"
      />
      <v-radio
        label="Не в маршруте"
        :value="2"
      />
    </v-radio-group>
  </v-layout>
</template>
<script>
import { placingTypes } from "./shipping-placing-types.js";
export default {
  data() {
    return {
      selected: 0,
    };
  },
  computed: {
    types() {
      return placingTypes;
    },
    shippingState() {
      return this.$store.getters["routePlanning/shippingState"];
    },
  },
  watch: {
    shippingState: {
      handler(value) {
        if (value?.notInRoute) {
          this.selected = this.types.NOTINROUTE;
        } else if (value?.notInCar) {
          this.selected = this.types.NOTINCAR;
        } else {
          this.selected = 0;
        }
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      const shippingState = {
        notInRoute: this.selected === this.types.NOTINROUTE ? true : false,
        notInCar: this.selected === this.types.NOTINCAR ? true : false,
      };
      this.$store.commit("routePlanning/setShippingState", shippingState);
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$emit("change");
    },
  },
};
</script>
